import { computed } from '@ember/object';
// eslint-disable-next-line import/default
import FieldKit from 'field-kit';
import JapanesePhoneFormatter from '../../utils/formatters/jp-phone-number-formatter';
import AuPhoneNumberFormatter from '../../utils/formatters/au-phone-number-formatter';
import GbPhoneNumberFormatter from '../../utils/formatters/gb-phone-number-formatter';
import InputText from './input-text';

// Removes formatting field-kit applies
const PHONE_NUMBER_NORMALIZE_REGEX = /([\s()+-])/g;

/**
 * This component renders a text input with phone number formatting. It is a extension of
 * <Prism::InputText /> and supports all the same properties.
 *
 * @example
 * ```
 * <Prism::InputPhone
 *   @value={{this.nameOfValueProperty}}
 *   @inputId="my-id"
 *   @inputClass="some-class some-other-class"
 *   @label="Phone Number"
 *   @placeholder="Put phone number here"
 *   @countryCode="US"
 *   @onChange={{action (mut nameOfValueProperty))}}
 * />
 * ```
 *
 */
export default InputText.extend({
  /**
   * @param {String} [countryCode="US"] - Country code to use for formatting. Defaults to US.
   */
  countryCode: 'US',
  /**
   * @override
   */
  maxlength: 17,
  /**
   * @override
   */
  inputType: 'tel',
  formatter: computed('countryCode', function () {
    switch (this.countryCode) {
      case 'AU':
        return new AuPhoneNumberFormatter();
      case 'GB':
        return new GbPhoneNumberFormatter();
      case 'JP':
        return new JapanesePhoneFormatter();
      default:
        return new FieldKit.PhoneFormatter();
    }
  }),
  actions: {
    _onChange(event) {
      const value = event.detail.value;
      if (this.onChange) {
        this.onChange(value.replace(PHONE_NUMBER_NORMALIZE_REGEX, ''), event);
      }
    }
  }
});